module.exports = __webpack_public_path__ + "img/3.81dd9f7d.jpg";